import DOMPurify from 'dompurify';

const HTML_ALLOWED_TAGS = [
  'section', 'header', 'main', 'footer', 'article',
  'div', 'span', 'p',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'strong', 'em', 'b', 'i', 'small', 'br', 'hr', 'a'
];

const HTML_ALLOWED_ATTR = [
  'class', 'style', 'title', 'role',
  'aria-label', 'aria-hidden',
  'colspan', 'rowspan', 'scope',
  'href', 'target', 'rel', 'download'
];

const RICH_TEXT_ALLOWED_TAGS = [
  'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
  'strong', 'em', 'b', 'i', 'u', 's', 'span', 'br', 'a'
];

const RICH_TEXT_ALLOWED_ATTR = [
  'href', 'target', 'rel', 'title'
];

const RICH_TEXT_TAG_PATTERN = /<\s*\/?\s*(?:p|h[1-6]|ul|ol|li|blockquote|pre|code|strong|em|b|i|u|s|span|br|a)(?:\s|\/?>)/i;

const isSafeDisplayHref = (value) => {
  const href = String(value ?? '').trim();
  if (!href) return false;
  if (href.startsWith('//')) return false;
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) {
    return /^https?:/i.test(href);
  }
  return true;
};

const sanitizeFragment = (html, allowedTags, allowedAttributes) => {
  const raw = String(html ?? '').trim();
  if (!raw) return '';

  const sanitized = DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button', 'svg', 'math', 'object', 'embed'],
    KEEP_CONTENT: true,
  });

  const template = document.createElement('template');
  template.innerHTML = sanitized;

    template.content.querySelectorAll('a').forEach((anchor) => {
      const href = anchor.getAttribute('href');
      if (!href || !isSafeDisplayHref(href)) {
        anchor.removeAttribute('href');
        anchor.removeAttribute('target');
        anchor.removeAttribute('rel');
      return;
    }

    if (anchor.getAttribute('target') === '_blank') {
      anchor.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return template.innerHTML.trim();
};

export const sanitizeHtmlFragment = (html) =>
  sanitizeFragment(html, HTML_ALLOWED_TAGS, HTML_ALLOWED_ATTR);

export const hasRichTextHtml = (value) =>
  RICH_TEXT_TAG_PATTERN.test(String(value ?? ''));

export const sanitizeRichTextFragment = (html) =>
  sanitizeFragment(html, RICH_TEXT_ALLOWED_TAGS, RICH_TEXT_ALLOWED_ATTR);
